import React from "react";
import { Box, Typography } from "@mui/material";
import {
  QueryStats as QueryIcon,
  SportsBaseball as PlayersIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import HomeSection from "./HomeSection";
import { homeCardHover } from "./homeStyles";
import { colors } from "../../theme";
import { BRAND_COLORS } from "../../utils/brandAssets";

const actions = [
  {
    title: "Stat Explorer",
    description: "Custom stat searches with shareable URLs",
    path: "/app/queryBuilder",
    icon: QueryIcon,
    accent: BRAND_COLORS.cyan,
  },
  {
    title: "Players",
    description: "Search & explore",
    path: "/app/players",
    icon: PlayersIcon,
    accent: "#a855f7",
  },
];

const QuickActions = () => {
  const navigate = useNavigate();

  return (
    <HomeSection title="More tools" subtitle="Dig deeper into the data">
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(2, 1fr)",
            sm: "repeat(2, 1fr)",
          },
          gap: 1.5,
        }}
      >
        {actions.map(({ title, description, path, icon: Icon, accent }) => (
          <Box
            key={path}
            onClick={() => navigate(path)}
            sx={{
              p: 1.5,
              borderRadius: 1.5,
              border: `1px solid ${colors.border}`,
              ...homeCardHover,
            }}
          >
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: `${accent}22`,
                mb: 1,
              }}
            >
              <Icon sx={{ fontSize: 20, color: accent }} />
            </Box>
            <Typography variant="body2" fontWeight={600}>
              {title}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {description}
            </Typography>
          </Box>
        ))}
      </Box>
    </HomeSection>
  );
};

export default QuickActions;
